import React, { useContext } from "react";
import { AppState } from "../lib/context/AppProvider";
import OptHeader from "./OptHeader";

const ExerciseHeader = () => {
    const {exercise, includeExerciseData} = useContext(AppState);
    
    return <>
        {exercise?.name && <OptHeader
            backgroundColor="#004990" 
            text={`${exercise.name.toUpperCase()} EXERCISE`} 
        />}
        {includeExerciseData && <OptHeader 
            backgroundColor="rgb(0, 81, 255)" 
            text="EXERCISE DATA ENABLED" 
        />}
    </>;
};

ExerciseHeader.propTypes = {};

export default ExerciseHeader;
